import { useEffect, useState } from "react";

import { useFetchData } from "../../apiHelpers";
import Button from "../../components/Button";
import CardWithTable from "../../components/CardWithTable";
import Toast from "../../components/Toast";
import Toolbar from "../../components/Toolbar";
import { ADMIN_USERS_COLUMNS, API_ADMIN_ROUTES } from "../../constants";
import { getOwnerType } from "../../helpers";
import useAdminUsersStore from "../../store/AdminUsers.store";
import useUserStore from "../../store/User.store";
import { getUsersTableFilters } from "../../utils/helpers/admin.helper.js";
import { filterListByKeywordGivenKeyNames } from "../../utils/helpers/objects";

import "./admin.scss";

const Admin = ({ table }) => {
  //#region //! States
  const [toggleSelectedOption, setToggleSelectedOption] = useState("left");
  const [ownerCount, setOwnerCount] = useState({ all: 0, my: 0 });
  const [filters, setFilters] = useState([]);
  const [dataToBeShown, setDataToBeShown] = useState(undefined);
  //#endregion

  //#region //! Get store actions and data
  const { email: userEmail } = useUserStore((state) => state.data.user);
  const { saveUsers } = useAdminUsersStore((state) => state.actions);
  //#endregion

  //#region //! Fetching data
  const { data: users, isLoading } = useFetchData({
    url: API_ADMIN_ROUTES.ADMIN_LIST,
  });
  //#endregion

  //#region //! Initializing stores
  useEffect(() => {
    if (isLoading) return;

    const allUsers = saveUsers(users);
    const myUsers = filterListByKeywordGivenKeyNames(allUsers, userEmail, [
      "createdBy",
    ]);

    const ownerType = getOwnerType(toggleSelectedOption);
    const dataByOwner = {
      all: allUsers,
      my: myUsers,
    };

    setDataToBeShown(dataByOwner[ownerType]);
    setOwnerCount({
      all: dataByOwner.all.length,
      my: dataByOwner.my.length,
    });
    setFilters(getUsersTableFilters(dataByOwner[ownerType]));
  }, [isLoading, saveUsers, toggleSelectedOption, userEmail, users]);
  //#endregion

  const headerCTA = (
    <Button
      href="/admin/users/add"
      size="small"
      className="toolbarHeaderCta"
      iconName="system-add"
      iconPosition="right"
    >
      Invite Advisors
    </Button>
  );

  return (
    <>
      <Toast />
      <header className="section-title">
        <h1>My Team</h1>
      </header>
      <CardWithTable
        isLoading={isLoading || !dataToBeShown}
        pluralTitle={"Users"}
        singularTitle={"User"}
        columns={ADMIN_USERS_COLUMNS}
        onClickToggle={setToggleSelectedOption}
        ownerCount={{ ...ownerCount }}
        toggleSelectedOption={toggleSelectedOption}
        ownerType={getOwnerType(toggleSelectedOption)}
        filters={filters}
        tableData={dataToBeShown}
      />
      <Toolbar
        title="Quick Actions"
        data={null}
        headerCTA={headerCTA}
        collapsible={false}
      />
    </>
  );
};

export default Admin;
